export default __webpack_public_path__ + "44e0f22f56a26a9d5ce92c9fcfedb7be.jpg";